<div class="camera-modal-container">
  <!-- Camera State -->
  <div *ngIf="currentState === 'camera'" class="camera-state">
    <div class="camera-view">
      <video
        #videoElement
        autoplay
        playsinline
        class="video-element"
      ></video>
    </div>

    <div class="camera-controls">
      <button
        mat-fab
        color="primary"
        (click)="capturePhoto()"
        class="capture-btn"
        aria-label="Capture photo"
      >
        <mat-icon>camera</mat-icon>
      </button>

      <button
        *ngIf="hasMultipleCameras"
        mat-mini-fab
        (click)="switchCamera()"
        class="switch-btn"
        aria-label="Switch camera"
      >
        <mat-icon>flip_camera_android</mat-icon>
      </button>

      <button
        mat-mini-fab
        color="warn"
        (click)="cancel()"
        class="close-btn"
        aria-label="Cancel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Preview State -->
  <div *ngIf="currentState === 'preview'" class="preview-state">
    <div class="preview-view">
      <img
        #previewImage
        [src]="capturedPhotoDataUrl"
        alt="Captured photo preview"
        class="preview-image"
      />
    </div>

    <div class="preview-controls">
      <button
        mat-raised-button
        (click)="retakePhoto()"
        class="retake-btn"
        aria-label="Retake photo"
      >
        <mat-icon>refresh</mat-icon>
        <span class="button-text">{{ 'Retake' | translate }}</span>
      </button>

      <button
        mat-raised-button
        color="primary"
        (click)="confirmAndUpload()"
        class="confirm-btn"
        aria-label="Confirm and upload"
      >
        <mat-icon>check</mat-icon>
        <span class="button-text">{{ 'Confirm' | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Uploading State -->
  <div *ngIf="currentState === 'uploading'" class="uploading-state">
    <mat-spinner diameter="60"></mat-spinner>
    <p class="uploading-text">{{ 'UploadingPhoto' | translate }}</p>
  </div>

  <!-- Success State -->
  <div *ngIf="currentState === 'success'" class="success-state">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <p class="success-text">{{ 'PhotoUploadedSuccessfully' | translate }}</p>
  </div>

  <!-- Error State -->
  <div *ngIf="currentState === 'error'" class="error-state">
    <mat-icon class="error-icon">error</mat-icon>
    <p class="error-text">{{ errorMessage }}</p>
    <div class="error-actions">
      <button
        mat-raised-button
        (click)="cancel()"
        class="cancel-error-btn"
      >
        <mat-icon>close</mat-icon>
        <span>{{ 'Close' | translate }}</span>
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="retakePhoto()"
        class="retry-btn"
      >
        <mat-icon>refresh</mat-icon>
        <span>{{ 'Try again' | translate }}</span>
      </button>
    </div>
  </div>
</div>
